import { useContext } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { linkToUsersAndTeamSettings } from '../../urls/linkToUsersAndTeamSettings';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import { useUnassignedSeatsBanner } from '../hooks/useUnassignedSeatsBanner';
import { trackClickManagePaidUsers } from '../utils/event-handlers';
import BannerContent from './BannerContent';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnassignedSeatsBanner = ({
  onClose
}) => {
  const trackUsage = useContext(TrackUsageContext);
  const {
    isFetching,
    unassignedSeatCount
  } = useUnassignedSeatsBanner(onClose);
  return /*#__PURE__*/_jsxs(BannerContent, {
    onClose: onClose,
    children: [isFetching && /*#__PURE__*/_jsx(LoadingSpinner, {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "routing-ui.routingRules.unassignedSeats_jsx",
      elements: {
        Link
      },
      options: {
        unassignedCount: unassignedSeatCount,
        linkProps: {
          external: true,
          onClick: () => trackUsage(trackClickManagePaidUsers('banner')),
          href: linkToUsersAndTeamSettings(true)
        }
      }
    })]
  });
};
UnassignedSeatsBanner.displayName = 'UnassignedSeatsBanner';
export default UnassignedSeatsBanner;